import React from 'react';
import './HomeWrap.scss';

const HomeWrap = () => {
  return (
    <div className="home-wrap">
      <iframe
        src="https://player.vimeo.com/video/859995066?h=6a9b6a3a28&autoplay=1&loop=1&muted=1"
        width="640"
        height="564"
        frameBorder="0"
        allow="autoplay; fullscreen"
      ></iframe>
    </div>
  );
};

export default HomeWrap;
